import HotelClass from "@material-symbols/svg-500/rounded/hotel_class.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const HotelClassIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: HotelClass });
	return <Icon />;
};

export default memo(HotelClassIcon);
